import type { PackageTimeEntry } from '@/types';

const ACTIVE_TIME_ENTRIES_KEY_PREFIX = 'active_time_entries';

const getCurrentUserStorageKey = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const rawUser = window.localStorage.getItem('user');
  if (!rawUser) {
    return null;
  }

  try {
    const parsedUser = JSON.parse(rawUser) as { id?: string | number };
    if (!parsedUser?.id) {
      return null;
    }

    return `${ACTIVE_TIME_ENTRIES_KEY_PREFIX}:${parsedUser.id}`;
  } catch {
    return null;
  }
};

export const getStoredActiveTimeEntries = (): PackageTimeEntry[] => {
  const storageKey = getCurrentUserStorageKey();
  if (!storageKey || typeof window === 'undefined') {
    return [];
  }

  const rawValue = window.localStorage.getItem(storageKey);
  if (!rawValue) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawValue);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const setStoredActiveTimeEntries = (entries: PackageTimeEntry[]) => {
  const storageKey = getCurrentUserStorageKey();
  if (!storageKey || typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(storageKey, JSON.stringify(entries));
};

export const clearStoredActiveTimeEntries = () => {
  const storageKey = getCurrentUserStorageKey();
  if (!storageKey || typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(storageKey);
};
